/*
  This top-level Navbar component loads one of the variants based on the type prop.
  Type can be one of: legacy, developer, developer-legacy, jobstobedone, empty
*/
import React from 'react';
import PropTypes from 'prop-types';

import EmptyNavbar from '../NavbarVariants/EmptyNavbar';
import DeveloperNavbar from '../NavbarVariants/DeveloperNavbar';
import DeveloperLegacyNavbar from '../LegacyNavbar/DeveloperLegacyNavbar';
import JobsToBeDoneNavbar from '../NavbarVariants/JobsToBeDoneNavbar';
import LegacyNavbar from '../LegacyNavbar';

export class DisconnectedNavbar extends React.PureComponent {
  navbarContent() {
    switch (this.props.type) {
      case ('empty'):
        return <EmptyNavbar />;

      case ('developer'):
        return <DeveloperNavbar />;

      case ('developer-legacy'):
        return <DeveloperLegacyNavbar />;

      case ('legacy'):
        return <LegacyNavbar />;

      case ('jobstobedone'):
      default:
        return <JobsToBeDoneNavbar />;
    }
  }

  render() {
    return (
      <div role="navigation" aria-label="navbar" className="apply-design-system">
        {(this.props.loading || this.props.error)
          ? <EmptyNavbar />
          : this.navbarContent()
        }
      </div>
    );
  }
}

DisconnectedNavbar.defaultProps = {
  type: 'legacy',
};

DisconnectedNavbar.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  type: PropTypes.string,
};

export default DisconnectedNavbar;
